export * from './src/loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';
